module.exports = {
    bestialMouths: {
        name: 'BESTIAL MOUTHS',
        text: 'Bestial Mouths, lead by the charismatic and power-voiced frontwoman Lynette Cerezo, is undoubtedly one\n' +
            'of the most unique and original artists of this century. BMB has thought about them for years, but their\n' +
            'previous location in LA made it too big of a mouthful. Now Lynette is located in Berlin and this\n' +
            'opportunity cannot be missed. Bestial Mouths\' music has a gloomy gothic substance, dark wave like sound,\n' +
            'and a fair amount of exciting disarrangement and noise, that creates a sonic journey alongside the\n' +
            'darker corners of life. Lynette\'s possessed stage persona and unearthly singing will shake the most\n' +
            'experienced heard-it-all listener out of their comfort zone. Bestial Mouths has released quite a few\n' +
            'albums and been a part of countless collaborations and reworks. This year they are seriously focused on\n' +
            'recording a new album. It is wonderful that they have found the time to stop by Tallinn this fall. If\n' +
            'you are intrigued and moved by strong voices that come out of the mouths of the likes of Diamanda Galas,\n' +
            'Lisa Gerrard or Siouxsie Sioux, and if murky noisy dark wave speaks to you, you know what to do.',
        youtube: 'https://www.youtube-nocookie.com/embed/pNwjIBZaKD0',
        facebook: 'https://www.facebook.com/bestialmouths',
        bandcamp: 'https://bestialmouths.bandcamp.com'
    },
    cryo: {
        name: 'CRYO',
        text: 'Sweden is usually a certain sign of quality in the music world, and this duo is undoubtedly one of the ' +
            'most important and stable artists in Swedish dark-electro. The band has only released five full-length ' +
            'albums in their 17 years of being active, but all of them are well-made wholesome pieces done in good ' +
            'taste. After being five years in the making, „The Fall Of Man“ was released in June this year, and ' +
            'instantly won the praise from media and audiences, quickly reaching the high spots in alternative music ' +
            'charts. It does not happen often that EBM and melodies are so brilliantly conjoined. The muscle of body ' +
            'music and the lyricism of synthpop, added a touch of psychedelia and cosmic feel via interesting effects ' +
            'and atmospheric sounds. A warm suggestion for the admirers of Front 242, Covenant and VNV Nation.',
        youtube: 'https://www.youtube.com/embed/_QFs9bHCe4g',
        facebook: 'https://www.facebook.com/cryosweden',
        bandcamp: 'https://cryosweden.bandcamp.com'
    },
    wychdoktor: {
        name: 'WYCHDOKTOR',
        text: 'This young Canadian has managed to do quite a lot already, having released a quantity of albums and ' +
            'remixes. Stylistically his creations vary from rhythmic noise to witch house, but he has also created ' +
            'dark ambient soundscapes that are absent of rhythm. Wychdoktor has depth, an unusual cognition, an' +
            ' extremely sharp ear and the skill to create an ominous dance music soundtrack to your most disturbing ' +
            'nightmare. Sterile creaks and scrunches, spatial feeling, grisly talking samples and machine-like stepping ' +
            'pace that can evolve to running at times. It\'s also worth mentioning that BMB will be Wychdoktor\'s first ' +
            'ritual in Europe! If you enjoy mysticism, you like This Morn\' Omina, ESA: Electronic Substance Abuse, ' +
            'Chainreactor, and you can imagine how Lustmord with sound with a beat – this is for you.',
        youtube: 'https://www.youtube.com/embed/4HU2RJI4ROA',
        facebook: 'https://www.facebook.com/wychdoktor',
        bandcamp: 'https://wychdoktor.bandcamp.com'
    },
    veliuNamai: {
        name: 'VĖLIŲ NAMAI',
        text: 'Abnormally beautiful and powerful music from the brain of Lithuanian Julius Mitė. It\'s visual and ' +
            'atmospheric. Vėlių Namai\'s focus is on ancient power-ridden sounds. This neo-folk is not a country dance, ' +
            'but a deep thrust to the heart to take over your soul and fill it with something enormous and wonderful.' +
            ' Vėlių Namai was born in Prague in 2006. So far he has released three albums, which are all unique, mostly ' +
            'instrumental journeys, with occasional ritualistic chants and shouts, and some guest vocalists. Julius' +
            ' draws his inspiration mostly from the Baltic and Lithuanian pagan past, using different folk instruments ' +
            'and guitar, combing them with ambient sounds and techno-like rhythms. This mixture gives life to something ' +
            'original and hypnotic - Vėlių Namai. If you can combine Dead Can Dance, Wardruna, Trentemøller and Sigur ' +
            'Rós, you have a close idea of the concoction that is happening here.',
        youtube: 'https://www.youtube.com/embed/T7_2PfIKwEs',
        facebook: 'https://www.facebook.com/veliunamai',
        bandcamp: 'https://veliunamai.bandcamp.com'
    },
    lolaKumtus: {
        name: 'LOLA KUMTUS',
        text: 'A mysterious duo from Helsinki, whose members are XX and XY, makes wonderful minimal music. A clear and ' +
            'cold sound, analogue synths, electro beats. Their non-sonic influences are according to their own words: ' +
            'alcoholism, eating disorders, mental instability and solitude. Is it really two lonely deranged Finnish ' +
            'drunks? It is hard to believe that they could create so elaborate and finessed music without a good ' +
            'chemistry between them and a sober-minded approach. Lola Kumtus\'s third full-length album will be released ' +
            'this fall via German label Young & Cold. We anticipate it with excitement, as their first live performance ' +
            'in Estonia! Keywords: oldschool, EBM, electro, minimal, post-industrial, italo and early synthpop.',
        youtube: 'https://www.youtube.com/embed/mM7ipF1BJ4g',
        facebook: 'https://www.facebook.com/lolakumtus',
        bandcamp: 'https://lolakumtus.bandcamp.com'
    },
    plasticWhore: {
        name: 'PLASTIC WHORE',
        text: 'It\'s true! Plastic Whore\'s only, cult status achieving album “Wet Planet” was released 15 years ago on ' +
            'this planet that keeps getting dryer. Multi-talent Jarmo Nuutre has since put together a myriad of  bands' +
            ' and projects (Skull Trading, Blood Pavilion, Talbot, Odota etc). How original the album was then and how' +
            ' well it has stood against the test of time does not need a further discussion. Last year there was a ' +
            'wandering thought among the BMB team that it would be great to see Mr. Nuutre growling with a guitar on ' +
            'top of machine rhythms and thanks to the right alignment of stars it is happening – Plastic Whore\'s new ' +
            'coming 15 years later on the anniversary of Wet Planet will be right before your eyes and ears in full ' +
            'glory in October.',
        youtube: 'https://www.youtube.com/embed/tfYQ8yYZQ0A',
        facebook: '',
        bandcamp: 'https://talklefthanded.bandcamp.com/album/wet-planet-2004'
    },
    kirurg: {
        name: 'KIRURG',
        text: 'Perhaps not so unknown for the locals, DJ 4-got-10 decided at one point that he would like to create' +
            ' the kind of music that he longs to play in his sets and that does not fit in the realms of his main bands' +
            ' Forgotten Sunrise and Deceitome. So began the creation of muscle-infused dance music influenced by dark ' +
            'techno, and spruced with heinous elements, humor and rock\'n\'roll. Who said techno has to be numb or ' +
            'merely mechanical? BMB is the first performance for Kirurg in history! If you equally like EBM, techno ' +
            'and The Cramps, you should give yourself this chance!',
        youtube: '',
        facebook: 'https://www.facebook.com/kirurgmusic',
        bandcamp: 'https://kirurg.bandcamp.com'
    }
}
